import React from 'react';
import { useAccount } from '~/features/club';
import { useTranslation } from '~/shared/utils';
import { StyledAccountGrid, StyledAccountGridItem } from './styled';
import { Text } from '~/shared/components';

export const ProfileDisplay = () => {
    const { account = {} } = useAccount();
    const { address, displayBirthday, email, firstname, gender, lastname, phone } = account;
    const { translate } = useTranslation();

    const withFallback = (value: string | null | undefined) => value || '_';

    const gendersDescription = {
        m: translate('form.values.gender.man'),
        f: translate('form.values.gender.woman'),
        x: translate('form.values.gender.other'),
    }[gender || ''];

    return (
        <StyledAccountGrid>
            <StyledAccountGridItem full>
                <Text variant="overline">{translate('form.label.email')}</Text>
                {withFallback(email)}
            </StyledAccountGridItem>
            <StyledAccountGridItem full>
                <Text variant="overline">{translate('form.label.phone')}</Text>
                {withFallback(phone)}
            </StyledAccountGridItem>
            <StyledAccountGridItem>
                <Text variant="overline">{translate('form.label.firstName')}</Text>
                {withFallback(firstname)}
            </StyledAccountGridItem>
            <StyledAccountGridItem>
                <Text variant="overline">{translate('form.label.lastName')}</Text>
                {withFallback(lastname)}
            </StyledAccountGridItem>
            <StyledAccountGridItem full>
                <Text variant="overline">{translate('form.label.address')}</Text>
                {withFallback(address?.street)}
            </StyledAccountGridItem>
            <StyledAccountGridItem>
                <Text variant="overline">{translate('form.label.postalCode')}</Text>
                {withFallback(address?.zipCode)}
            </StyledAccountGridItem>
            <StyledAccountGridItem>
                <Text variant="overline">{translate('form.label.city')}</Text>
                {withFallback(address?.city)}
            </StyledAccountGridItem>
            <StyledAccountGridItem full>
                <Text variant="overline">{translate('form.label.birthday')}</Text>
                {withFallback(displayBirthday)}
            </StyledAccountGridItem>
            <StyledAccountGridItem full>
                <Text variant="overline">{translate('form.label.gender')}</Text>
                {withFallback(gendersDescription)}
            </StyledAccountGridItem>
        </StyledAccountGrid>
    );
};
